
import {defineComponent, PropType} from "vue";
import {AxiosError} from "axios";

export default defineComponent({
  name: "ErrorView",
  props: {
    error: {
      required: true,
      type: Object as PropType<AxiosError>
    }
  },
  computed: {
    responseStatus(){
      return this.error.response?.status || 400;
    },
    responseMessage(){
      if(this.responseStatus === 404){
        return "Мы не смогли ничего найти"
      }else{
        return this.error.message;
      }
    }
  }
})
